import React from "react";
import { CircleMarker, Polyline } from "react-leaflet";
import { toLatLng } from "../../../utils/geo";
import { useTrapsiteEditorContext } from "./TrapsiteEditorContext";

interface Props {
  /** Where the address last resolved to, when it differs from the pin. */
  geocodedGps: { lat: number; lon: number } | null;
  /** True once the gap is past the warning threshold. */
  drifted: boolean;
}

/**
 * The gap between a collection location's pin and its geocoded address.
 *
 * Only the drift visualisation: the draggable pin itself belongs to
 * EditorMarkers, which owns every pin the editor shows. Rendering one here too
 * put two draggable markers on the same point, and dragging the wrong one
 * bypassed the refit.
 */
const DraftMarker: React.FC<Props> = ({ geocodedGps, drifted }) => {
  const editor = useTrapsiteEditorContext();
  const draft = editor.draft;

  if (!draft || !geocodedGps || !drifted) return null;

  return (
    <>
      {/* The gap made visible, so "snap to address" has a destination the
          user can see before committing to it. */}
      <Polyline
        positions={[toLatLng(draft.gps), toLatLng(geocodedGps)]}
        pathOptions={{ color: "#f4c000", weight: 2, dashArray: "6 6" }}
      />
      <CircleMarker
        center={toLatLng(geocodedGps)}
        radius={6}
        pathOptions={{
          color: "#f4c000",
          fillColor: "#f4c000",
          fillOpacity: 0.6,
        }}
      />
    </>
  );
};

export default DraftMarker;
